// extracted by mini-css-extract-plugin
export default {"checkbox_wrapper_46":"CheckBox_checkbox_wrapper_46__I-rzH","cbx":"CheckBox_cbx__g1lP4","inp_cbx":"CheckBox_inp_cbx__8BgmV","wave-46":"CheckBox_wave-46__x8vYz"};